module.exports = __webpack_public_path__ + "static/media/next-button.76816e11.svg";